<template>
  <div class="additional-coordinates">
    <BlockRepeater
      v-slot="slotProps"
      class=""
      title=""
      inline
      :label="$t('processes.fields.add_extra_coordinates')"
      :path="path"
      :values="values"
      :disabled="disabled"
      @changed="handleChanged"
      @removed="handleChanged"
    >
      <FieldSet
        :key="coordsKey"
        class="mb-2"
        :values="internalData"
        :fields="fields"
        :validation="null"
        :debounce="1000"
        :layout="layout"
        :disabled="disabled"
        :path="`${path}.${slotProps.id}`"
        @input="$event => handleInput({ name: $event.name, value: $event.value, index: slotProps.id })"
      />
    </BlockRepeater>
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'
import BlockRepeater from '@/components/form/BlockRepeater'

import { required } from 'vuelidate/lib/validators'
import { isLatitude, isLongitude } from '@/services/validation'

export default {
  name: 'AdditionalCoordinates',
  components: {
    FieldSet,
    BlockRepeater,
  },
  props: {
    values: {
      type: Object,
      default: () => { },
    },
    path: {
      type: String,
      default: 'Location.AdditionalCoordinates',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    recordValues: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      fields: {
        'Latitude': {
          'type': 'float',
          'title': '',
        },
        'Longitude': {
          'type': 'float',
          'title': '',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['Latitude', 'Longitude'],
      }],
      validation: {
        'Latitude': {
          required,
          isLatitude,
        },
        'Longitude': {
          required,
          isLongitude,
        },
      },
      internalData: {},
      showAlert: false,
      coordsKey: 0,
    }
  },
  computed: {
    additionalCoordinates() {
      return this.internalData.Location.AdditionalCoordinates
    },
  },
  watch: {
    values: {
      immediate: true,
      handler(values) {
        this.internalData = JSON.parse(JSON.stringify(values))
      },
    },
  },
  methods: {
    handleChanged({ index }) {
      const noItemPresent = !this.additionalCoordinates[index]

      noItemPresent
        ? this.additionalCoordinates.push({ Latitude: '', Longitude: '' })
        : this.additionalCoordinates.splice(index, 1)

      if (!noItemPresent) {
        this.$emit('setAdditionalCoordintaes', { coordinates: this.additionalCoordinates })
      }
    },

    handleInput({ name, value, index }) {
      const field = name.split('.').pop()
      this.handleUpdate({ name: field, value, index })
    },

    handleUpdate({ name, value, index }) {
      if (!['Latitude', 'Longitude'].includes(name)) {
        return
      }

      const coordinates = value.split(',').map(entry => parseFloat(entry.trim())).filter(Boolean)

      if (coordinates.length > 1) {
        const [latitude, longitude] = coordinates

        this.additionalCoordinates[index].Longitude = longitude
        this.additionalCoordinates[index].Latitude = latitude
        this.coordsKey++

        //this.showAlert = true
      } else {
        this.additionalCoordinates[index][name] = parseFloat(value.trim())
      }
      this.$emit('setAdditionalCoordintaes', { coordinates: this.additionalCoordinates })
    },
  },
}
</script>
<style lang="scss" scoped>
.BlockRepeater__add {
  padding-top: 0;
}

.BlockRepeaterItem {
  &.inline {
    align-items: flex-start;
    gap: 1em;

    .BlockRepeaterItem__footer {
      padding: 0;
    }
  }
}

.additional-coordinates {
  margin-left: 4em;
}
</style>
